













import { ClearCardViewStateMixin } from '@/mixins/clearViewStateMixin'
import { CloseViewButtonElInterface } from '@/config/interfaces'

export default ClearCardViewStateMixin.extend({
  name: 'CloseViewButtonEl',

  methods: {
    closeCard (): void {
      this.clearCardState()
      this.$router.back()
    }
  },

  props: {
    templateItemData: {
      type: Object as () => CloseViewButtonElInterface,
      required: true
    }
  }
})
